module.exports = __webpack_public_path__ + "static/desktop/img/hero-1.384f0934.jpg";